/*
Author: Hoi Tak Leung
Email: hoi.leung@greedy.mx
Last Update: 25/09/2023
*/

import { Typography, Container, CssBaseline, Grid, Box } from "@mui/material";

import SectionBack from "../../../assets/stock-coworking.webp";

import "./IndustriesSection.css";
import { useScrollReveal } from "../../../helpers/ScrollReveal";
import { useLanguageContext } from "../../../context/languageContext";
import { textlanguages } from "../../../data/textOfThePage";
import { useLocation } from "react-router-dom";

export default function IndustriesSectionSection() {
  const { languageSelected } = useLanguageContext();
  const location = useLocation();
  useScrollReveal([
    {
      selector: ".revealIndustries",
      options: {
        distance: "100px",
        duration: 1000,
        easing: "ease-out",
        origin: "left",
        reset: false,
        interval: 500,
      },
    },
    {
      selector: ".revealIndustriesIcons",
      options: {
        distance: "100px",
        duration: 1000,
        easing: "ease-out",
        origin: "left",
        reset: false,
        interval: 300,
      },
    },
  ]);
  return (
    <Container
      disableGutters
      maxWidth={false}
      className="container-section-industries"
      sx={{ bgcolor: location.pathname === "/industries" ? "#fff" : "F4F4F4" }}
    >
      <CssBaseline />
      <Grid container sx={{ display: "flex" }}>
        <Grid
          item
          container
          xs={12}
          lg={6}
          xl={6}
          sx={{
            marginTop: "4vh",
            marginBottom: "5vh",
            order: { xs: 0, md: 0, lg: 1 },
          }}
        >
          <Grid item container xs={1} lg={2}></Grid>
          <Grid item container xs={10} lg={9}>
            <Box className="title-box">
              <Typography
                variant="h3"
                sx={{ textAlign: { xs: "center", lg: "left", xl: "left" } }}
                className="section-industries-header revealIndustries"
              >
                {textlanguages[languageSelected].Industries.title}
              </Typography>
            </Box>
            <Typography
              variant="h5"
              className="section-industries-description revealIndustries"
            >
              {textlanguages[languageSelected].Industries.description}
            </Typography>
            <Grid
              container
              spacing={2}
              sx={{ textAlign: "center", color: "black" }}
              className="revealIndustries"
            >
              {textlanguages[languageSelected].Industries.typeOfIndustries.map(
                (industry) => (
                  <Grid
                    item
                    xs={4}
                    lg={3}
                    className="revealIndustriesIcons"
                    key={industry.title}
                  >
                    <Box className="industries-list-box">
                      <img
                        src={industry.icon}
                        alt={`Ícono ${industry.title}`}
                      />
                      <Typography variant="subtitle1">
                        {industry.title}
                      </Typography>
                    </Box>
                  </Grid>
                )
              )}
            </Grid>
          </Grid>
          <Grid item container xs={1} lg={1}></Grid>
        </Grid>
        <Grid
          item
          container
          xs={12}
          sx={{
            display: { xs: "block", lg: "none", xl: "none" },
            order: { xs: 1, md: 0, lg: 1 },
            overflowX: "hidden",
          }}
        >
          <img
            src={SectionBack}
            className="mobile-section-background"
            alt="Imagen Múltiples Industrias"
            style={{ height: "100% !important" }}
          />
        </Grid>
        <Grid
          item
          container
          lg={6}
          xl={6}
          sx={{
            display: { xs: "none", lg: "block", xl: "block" },
            height: "inherit",
          }}
        >
          <img
            src={SectionBack}
            className="section-industries-background"
            alt="Imagen Múltiples Industrias"
          />
        </Grid>
      </Grid>
    </Container>
  );
}
